<template lang="pug">
  #member-center-admin-invite-new
    BModal(:active.sync='inviteModalActive' has-modal-card)
      BNotification(:active.sync="error" type="is-danger" :duration="3000")
        | {{ errorMessage }}
      .modal-card
        section.modal-card-body.modal-body-radius
          WtTitle(card-title) Invite New Member
          p.content Invite a new member to your program by completing the form below:

          .columns
            .column.is-half
              BField.name-fields(
                :message="errors.first('first name')"
                :type="{'is-danger': errors.has('first name')}"
                :addons="false"
              )
                WtLabel(
                  slot="label"
                  text="First Name"
                  label-for="firstName"
                  required
                )
                BInput#firstName(
                  name="first name"
                  v-model="firstName"
                  v-validate="'required'"
                  @input="initialEntry = true"
                  key="test"
                )
            .column.is-half
              BField.name-fields(
                :message="errors.first('last name')"
                :type="{'is-danger': errors.has('last name')}"
                :addons="false"
              )
                WtLabel(slot="label" text="last name" label-for="lastName" required)
                BInput#lastName(
                  name="last name"
                  v-model="lastName"
                  v-validate="'required'"
                  @input="initialEntry = true"
                  key="test2"
                )
          .columns.is-multiline.is-variable
            .column.is-full
              BField(
                :type="{'is-danger': errors.has('emailAddress')}"
                :message="errors.first('emailAddress')"
                :addons="false"
              )
                WtLabel(slot="label" text="Email Address" label-for="email" required)
                BInput#email(
                  ref="emailAddress"
                  name="emailAddress"
                  type="email"
                  v-validate="'required|email'"
                  placeholder="name@email.com"
                  data-vv-as="email"
                  v-model="email"
                )
            .column.is-full
              BField(
                label="Confirm Email Address"
                label-for="emailConfirm"
                :type="{'is-danger': errors.has('emailConfirm')}"
                :message="errors.first('emailConfirm')"
              )
                BInput#emailConfirm(
                  name="emailConfirm"
                  type="email"
                  v-validate="'required|confirmed:emailAddress'"
                  data-vv-as="email"
                  placeholder="name@email.com"
                  v-model="emailConfirm"
                )

      .modal-card-foot.is-block.has-background-white
        .level.is-mobile
          .level-left
          .level-right
            .level-item
              WtButton(
                color="primary"
                @click.native="invite"
                :loading="outsiderInviteProcessing"
                :disabled="!initialEntry || errors.any()"
              ) SEND INVITE

    WtTitle(card-title) Invite Member

    WtButton(fullwidth @click.native="inviteModalActive = true") INVITE NEW MEMBER
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";

export default {
  name: "MemberCenterAdminInviteNew",

  components: { WtTitle, WtButton, WtLabel },

  data() {
    return {
      inviteModalActive: false,
      error: false,
      errorMessage: null,
      email: null,
      emailConfirm: null,
      firstName: null,
      lastName: null,
      initialEntry: false
    };
  },

  computed: {
    ...mapGetters("invites", ["outsiderInviteProcessing"])
  },

  methods: {
    ...mapActions("invites", ["inviteOutsider"]),
    ...mapActions(["snackBar"]),

    async invite() {
      const validation = await this.$validator.validateAll();

      if (!validation) {
        return;
      }

      const response = await this.inviteOutsider(this.email);

      if (response.error) {
        this.error = true;
        this.errorMessage = response.message;
      } else {
        this.inviteModalActive = false;

        this.snackBar({
          message: `${this.email} has been invited.`
        });

        await this.$validator.reset();
        this.email = null;
        this.emailConfirm = null;
        this.firstName = null;
        this.lastName = null;
      }
    }
  }
};
</script>

<style lang="sass">
#member-center-admin-invite-new
  .modal-body-radius
    border-radius: $radius-large $radius-large 0 0

  .modal-card-foot
    border-top: none
    padding-top: .25rem
    padding-bottom: 1.5rem

  .name-fields
    margin-bottom: 0

  .field-spacing:not(:last-child)
    margin-bottom: 1.15rem
</style>
